/**
 * Helper class for URL operations
 */
export class URLHelper {
  /**
   * Extrai todos os parâmetros da URL
   * @returns {Object} Object with all URL parameters as key-value pairs
   */
  static getAllUrlParams() {
    const params = {};

    try {
      // Get the query string from the URL
      const queryString = window.location.search;

      // Create a URLSearchParams object
      const urlParams = new URLSearchParams(queryString);

      // Convert to object
      const entries = urlParams.entries();
      for (let entry = entries.next(); !entry.done; entry = entries.next()) {
        const [key, value] = entry.value;
        params[key] = value;
      }
    } catch (error) {
      console.error('Error extracting URL parameters:', error);
    }

    return params;
  }

  /**
   * Obtém um parâmetro da URL e converte para um array separado por vírgulas
   * @param {string} paramName - O nome do parâmetro da URL
   * @returns {string[]} Array com os valores separados por vírgula
   */
  static getParamAsArray(paramName) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get(paramName);

      if (!paramValue) {
        return [];
      }

      return paramValue.split(',').map((item) => item.trim());
    } catch (error) {
      console.error(
        `Error extracting URL parameter '${paramName}' as array:`,
        error
      );
      return [];
    }
  }
}
